<template lang="pug">
    .contentpage
        .section(v-if="filteredSections.length" v-for="(section, index) in filteredSections" :key="section.id" :class="section.key")
            Heading(v-if="section.key === 'heading'" :section="section")
            .container.content.op.has-text-centered(v-if="section.key === 'heading'")
                .column.is-offset-1.is-10
                    h5.is-size-5-desktop.is-size-6-touch {{member.name}}
                    h6.is-size-6-desktop {{member.company}}
            ImageSection(v-if="section.key === 'image'" :section="section")
            ServiceDescription(v-if="section.key === 'service-description'" :section="section")
            PhotoAlbum(v-if="section.key === 'photoalbum'" :section="section")
        .container.evaluation-container(v-if="processedEvaluation && processedEvaluation.length > 0")
            .is-offset-1.content-wrap.is-10.column
                .evaluation(v-if="processedEvaluation" :class="{collapsed: collapsed}")
                    .information.content-wrap(v-for="information in processedEvaluation")
                        .content.speech-bubble.bubble-left.column.is-5.z-depth-1(v-for="content in information.contents")
                            .content-img(v-if="content.images && content.images.length > 0" v-for="image in content.images")
                                img(:src="getImage(image).src" :alt="image.name")
                            .content-text(v-html="content.text")
                        .reactions.speech-bubble.bubble-right.column.is-offset-7.is-5.z-depth-1(v-if="information.reactions && information.reactions.length > 0")
                            .reaction(v-for="reaction in information.reactions")
                                .type-radio(v-if="reaction.input_type == 'radio'")
                                    label
                                    input.radio(
                                        :type="reaction.input_type"
                                        :disabled="true"
                                        :checked="reaction.id == information.answer"
                                    )
                                    | &nbsp; {{ reaction.contents[0].title }}
                                .type-radio(v-else-if="reaction.input_type == 'text'")
                                    label
                                    .input(
                                        :type="reaction.input_type"
                                        :disabled="true"
                                        v-html="reaction.contents[0].text"
                                    )
                                .type-checkbox(v-if="reaction.input_type == 'select'")
                                    label
                                    input.checkbox(
                                        type="checkbox"
                                        :disabled="true"
                                        :checked="reaction.id == information.answer"
                                    )
                                    | &nbsp; {{ reaction.contents[0].title }}

                button.button.is-primary.toggle-collapse(@click="toggleCollapse") {{collapsedText}}
                button.button.is-light.is-pulled-right.print-eval(@click="print")
                    span.icon.is-small
                        i.fas.fa-print
                    | &nbsp;&nbsp;Umfrage ausdrucken
</template>

<script>

// import _ from 'lodash'
import { mapGetters } from 'vuex'

import Heading from '@/components/Heading'
import ImageSection from '@/components/ImageSection'
import ServiceDescription from '@/components/ServiceDescription'
import PhotoAlbum from '@/components/PhotoAlbum'

export default {
    name: 'ServicePage',
    components: {
        Heading,
        ImageSection,
        ServiceDescription,
        PhotoAlbum,
    },
    data() {
        return {
            collapsed: true,
            collapsedText: 'Umfrage aufklappen'
        }
    },
    computed: {
        filteredSections() {
            return this.sections.filter(section => {
                return section.key === 'heading'
                    || section.key === 'image'
                    || section.key === 'service-description'
                    || section.key === 'photoalbum'
            })
        },
        processedEvaluation() {
            return JSON.parse(this.evaluation.data)
        },
        ...mapGetters({
            sections: 'currentPage/sections',
            evaluation: 'currentPage/pageEvaluation',
            member: 'currentPage/member'
        })
    },
    methods: {
        print() {
            let open = this.collapsed

            if (this.collapsed === true) {
              this.collapsed = false
            }
            setTimeout(() => {
              window.print()
              if(open){
                this.collapsed = true
              }
            }, 10)
        },
        getImage(image) {
            if (! image) return false

            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            let fit = _.get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1'
            const parameters = {
                ... _.get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups'),
            }
            let { w, h, fx, fy, fz } = parameters

            let width, height, aspectRatio

            width = image.width / fz
            height = image.height / fz
            aspectRatio = width / height

            height = Math.min(window.innerWidth >= 1088 ? 780 : 400, height)
            width = height * aspectRatio

            if (w && h) {
                aspectRatio = w / h

                height = Math.min(window.innerWidth >= 1088 ? 780 : 400, image.height / fz)
                width = height * aspectRatio

                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`)
            } else if (! w && ! h) {
                fit += `&h=${height}`
            }

            let table = 'images'
            if (image.upload) table = 'uploads'

            return {
                src: `${storageRoute}/${table}/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/${table}/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/${table}/${image.id}/${image.name}?${fit}&preview=blur`,
                width,
                height,
                aspectRatio,
            }
        },
        toggleCollapse() {
            if (this.collapsed === true) {
                this.collapsedText = 'Umfrage zuklappen'
            }else this.collapsedText = 'Umfrage aufklappen'
            this.collapsed = !this.collapsed
        }
    }
}

</script>

<style lang="sass" scoped>
    @import "~bulma/sass/utilities/mixins";
    @import "@/assets/sass/variables.sass";

    .content.op
        h5, h6
            font-weight: normal
            margin: 0
    .evaluation
        background-color: #dae3e8
        padding-top: 24px
        padding-bottom: 24px
        padding-left: 20px
        padding-right: 25px
        margin-bottom: 50px
        .header
            background-color: $primary
    .collapsed
        height: 250px
        overflow: hidden
        background-image: linear-gradient(to bottom, transparent, white)
        border-bottom-left-radius: 10px
        border-bottom-right-radius: 10px
    .speech-bubble
        position: relative
        background-color: #fff
        border-radius: 10px
    .speech-bubble:after
        position: absolute
        content: ""
        width: 0
        height: 0
        border-style: solid
    .bubble-left
        // box-shadow: 4px 3px 10px -1px rgba(0,0,0,0.75)
        position: relative
        margin-bottom: 5px
    .bubble-left:after
        border-width: 10px 10px 10px 0
        top: 15px
        left: -10px
        border-color: transparent #fff transparent transparent
    .bubble-right
        // box-shadow: -4px 3px 10px -1px rgba(0,0,0,0.75)
        position: relative
        margin-top: 24px
    .bubble-right:after
        border-width: 10px 0 10px 10px
        top: 15px
        right: -10px
        border-color: transparent transparent transparent #fff
    .print-eval
        margin-left: 10px
    .evaluation-container
        margin-bottom: 50px
</style>
<style>
@media print{
    .section.heading,
    .section.post,
    .section.image,
    .section.service-description,
    .section.photoalbum,
    .comments,
    .main-menu-wrapper,
    header,
    footer,
    button{
      display:none !important;
    }

}
</style>
